import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderWithIcon from '../components/common/HeaderWithIcon';
import payApi from '../api/pay';
import { useAuth } from '../context/AuthContext';
import { Copy } from 'lucide-react';

export default function PaymentRequest() {
  const { id } = useParams();
  const { tokens } = useAuth();
  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchRequest = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await payApi.getPaymentRequest(tokens.access.token, id);
        if (response.status === 200 && response.data.success) {
          setRequest(response.data.data);
        } else {
          setError('Failed to fetch payment request');
        }
      } catch (err) {
        setError('Error fetching payment request');
      } finally {
        setLoading(false);
      }
    };
    if (tokens?.access?.token && id) {
      fetchRequest();
    }
  }, [tokens, id]);

  const handleCopy = () => {
    if (request?.id) {
      navigator.clipboard.writeText(request.id);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    }
  };

  return (
    <div className='min-h-screen relative overflow-hidden'>
      <HeaderWithIcon title='Payment Request Details' />
      <div className='px-5 pt-4'>
        {loading ? (
          <div className='py-4 text-center text-gray-500'>Loading...</div>
        ) : error ? (
          <div className='py-4 text-center text-red-500'>{error}</div>
        ) : !request ? (
          <div className='py-4 text-center text-gray-500'>No data found.</div>
        ) : (
          <div className='max-w-xl mx-auto bg-white rounded-md shadow border p-4'>
            <h2 className='text-lg font-bold mb-4 text-center'>Payment Request Info</h2>
            <div className='grid grid-cols-1 gap-2 text-sm'>
              <div className='flex justify-between items-center'>
                <span className='font-semibold'>ID:</span>
                <span className='flex items-center gap-2 relative'>
                  {request.id}
                  <button
                    onClick={handleCopy}
                    className='p-1 rounded hover:bg-gray-100 focus:outline-none border border-gray-200'
                    title='Copy to clipboard'
                  >
                    <Copy size={16} className='text-gray-500' />
                  </button>
                  {copied && <span className='bg-green-600 text-white text-xs ml-1 absolute right-0 p-.2 rounded-xl'>Copied!</span>}
                  
                </span>
              </div>
              <div className='flex justify-between'><span className='font-semibold'>Name:</span> <span>{request.name || '-'}</span></div>
              <div className='flex justify-between'><span className='font-semibold'>Phone:</span> <span>{request.phone || '-'}</span></div>
              <div className='flex justify-between'><span className='font-semibold'>Amount:</span> <span>{request.amount}</span></div>
              <div className='flex justify-between'><span className='font-semibold'>Currency:</span> <span>{request.currency}</span></div>
              <div className='flex justify-between'><span className='font-semibold'>Status:</span> <span>{request.status}</span></div>
              <div className='flex justify-between'><span className='font-semibold'>Reference #:</span> <span>{request.reference_number || '-'}</span></div>
              <div className='flex justify-between'><span className='font-semibold'>Created At:</span> <span>{request.created_at ? new Date(request.created_at).toLocaleString() : '-'}</span></div>
              <div className='flex justify-between'><span className='font-semibold'>Updated At:</span> <span>{request.updated_at ? new Date(request.updated_at).toLocaleString() : '-'}</span></div>
              {request.purpose && <div className='flex justify-between'><span className='font-semibold'>Purpose:</span> <span>{request.purpose}</span></div>}
              {request.address && <div className='flex justify-between'><span className='font-semibold'>Address:</span> <span>{request.address}</span></div>}
              {request.line_items && <div className='flex justify-between'><span className='font-semibold'>Line Items:</span> <span>{JSON.stringify(request.line_items)}</span></div>}
              {request.executor_id && <div className='flex justify-between'><span className='font-semibold'>Executor ID:</span> <span>{request.executor_id}</span></div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
} 